import React from 'react';

import {
  ALL_DAYS,
  PAST_7_DAYS,
  PAST_30_DAYS,
} from '../consts';

// styles
import styles from '../../../my-events/status-filter-dropdown/styles-module.css';

// Messages
import messages from '../locale';

const TimeFilterDropdown = (props) => {
  return (
    <div className={styles.wrapper}>
      {props.customIcon}
      <select className={`${styles.dropdown} timeFilterDropdown`}
        value={props.selectedStatus}
        onChange={(e) => props.handleTimeFilterChange(e.target.value)}
      >
        <option key={ALL_DAYS} value={ALL_DAYS}>
          {props.intl.formatMessage(messages.allDays)}
        </option>
        <option key={PAST_7_DAYS} value={PAST_7_DAYS}>
          {props.intl.formatMessage(messages.pastSevenDays)}
        </option>
        <option key={PAST_30_DAYS} value={PAST_30_DAYS}>
          {props.intl.formatMessage(messages.pastThirtyDays)}
        </option>
      </select>
    </div>
  );
};

export default TimeFilterDropdown;
